<template>
    <organisation-index>
        <template v-slot:title>
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">Clients</h1>
        </template>
        <template v-slot:searchfilter>
            <search-filter :show-filter="false" v-model:value="form.search" class="w-1/2 max-w-md mr-4"
                           @reset="reset"></search-filter>
        </template>
        <template v-slot:filters>
            <select id="status" v-model="form.filter.status"
                class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value selected v-html="'Please Select'"></option>
                <option value="active">Active</option>
                <option value="archived">Archived</option>
            </select>
            <select id="project_status" v-model="form.filter.country"
                    class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value selected v-html="'Country'"></option>
                <option v-for="country in filters.countries" :value="country.id"
                        v-html="country.name"></option>
            </select>
            <select id="project_status" v-model="form.filter.sort_by"
                    class="mt-1 block w-2/3 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value selected v-html="'Sort by'"></option>
                <option v-for="(sortby,index) in filters.sortby" :value="index"
                        v-html="sortby"></option>
            </select>
            <select id="project_status" v-model="form.filter.direction"
                    class="mt-1 block w-1/2 bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-gray-900 focus:border-gray-900 sm:text-sm">
                <option value selected v-html="'Direction'"></option>
                <option value="asc" v-html="'Asc'"></option>
                <option value="desc" v-html="'Desc'"></option>
            </select>
        </template>
        <Head title="Clients"/>
        <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Name
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        CMID
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Location
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Phone
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-center text-xs text-gray-500 uppercase tracking-wider">
                                        Contacts
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Group
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="organisations.data.length > 0"
                                    v-for="(organisation,index) in organisations.data" :key="index"
                                    :class="{'bg-gray-100': index % 2}" class="hover:bg-gray-50 cursor-pointer">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <Link :href="route('frontend.organisations.clients.organisation.show' , organisation.id)">
                                            <div class="text-sm text-gray-900">{{ organisation.name }}</div>
                                            <div class="text-sm text-gray-500">{{ organisation.registered_legal_name }}</div>
                                        </Link>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ organisation.cmid || '—' }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <div class="text-sm text-gray-900">{{ organisation.region }}</div>
                                        <div class="text-sm text-gray-500">{{ organisation.country }}</div>
                                    </td>
                                    <td class="flex flex-col px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="organisation.telephone !== null">T: {{ organisation.telephone }}</span>
                                        <span v-if="organisation.mobile !== null">M: {{ organisation.mobile }}</span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <div class="w-full flex justify-center items-center gap-3">
                                            <span class="underline text-pitch-purple text-gray-500 " @click="editContacts(organisation)">{{ Object.keys(organisation.contacts).length }}</span>
                                            <button @click="editContacts(organisation)" type="button" class="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-amaze-coral hover:bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                <PlusSmIcon class="h-4 w-4 text-white" aria-hidden="true" />
                                            </button>
                                        </div>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <span v-if="organisation.groups.length > 0" v-for="(group, index) in organisation.groups" :key="index">
                                              <span>{{ group.name }}</span>
                                              <span v-if="index + 1 < organisation.groups.length">, </span>
                                            </span>
                                        <span v-else>-------</span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 inline-flex">
                                        <Link
                                            class="mr-3"
                                            :href="route('frontend.organisations.clients.organisation.show' , organisation.id)">
                                            <PencilAltIcon class="w-5 h-5 text-light-pitch-purple"></PencilAltIcon>
                                        </Link>
                                        <button
                                            v-if="auth_roles.includes('super-admin') || auth_roles.includes('administrator')"
                                            type="button"
                                            @click="triggerWarning(organisation)">
                                            <TrashIcon class="w-5 h-5 text-red-500"></TrashIcon>
                                        </button>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td colspan="7"
                                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        There are no clients available for your search criteria.
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Pagination :links="organisations.links"/>

            </div>
        </div>
        <CreateContacts ref="createContactsSlideOut" />
    </organisation-index>
</template>

<script>

import Authenticated from "@/Layouts/Authenticated.vue";
import OrganisationIndex from "@/Pages/Frontend/Organisations/Index"
import Pagination from "@/Components/Pagination.vue";
import {reactive, ref, watch, computed} from "vue";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";
import {useForm, usePage, Link, Head} from "@inertiajs/vue3";
import SearchFilter from "@/Components/SearchFilter.vue";
import { PencilAltIcon, TrashIcon } from "@heroicons/vue/outline";
import { PlusSmIcon } from "@heroicons/vue/solid";
import CreateContacts from "@/Components/SlideOuts/CreateContacts";
import SlideoutFlashMessage from "@/Components/SlideoutFlashMessage";

export default {
    layout: Authenticated,
    components: {
        Pagination,
        OrganisationIndex,
        SearchFilter,
        Link,
        PencilAltIcon,
        PlusSmIcon,
        Head,
        CreateContacts,
        SlideoutFlashMessage,
        TrashIcon
    },
    props: {
        organisations: Object,
        filters: Object
    },
    setup() {
        const auth_roles = computed(() => usePage().props.auth.roles)

        return {
            auth_roles,
        }
    },
    data() {
        return {
            form: useForm({
                search: null,
                filter: {
                    status: this.filters.status ? this.filters.status : 'active',
                    country: "",
                    sort_by: "name",
                    direction: "asc"
                },
            }),
        }
    },
    methods: {
        reset() {
            this.form.reset()
        },
        editContacts(organisation) {
            this.$refs.createContactsSlideOut.organisation = organisation;
            this.$refs.createContactsSlideOut.contacts = organisation.contacts;
            this.$refs.createContactsSlideOut.open();
        },
        triggerWarning(organisation) {
            this.$swal.fire({
                title: 'Delete Client',
                html: "You are deleting a client. <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then((result) => {
                if (result.isConfirmed) {
                    // Delete the invoice
                    this.$inertia.delete(route('frontend.organisations.clients.organisation.delete', organisation.id),
                        {
                            preserveScroll: false,
                            onSuccess: (page) => {},
                            onError: (page) => {
                                this.loading = false
                                this.showErrors = true;
                            }
                        },
                    );
                }
            });
        }
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function() {
                this.$inertia.get(route('frontend.organisations.clients.index'), pickBy(this.form), {
                    preserveState: true
                });
            }, 500),
        },
    },
}
</script>
